import React from 'react';
import Div from '@/shared/Div';
import Image from '@/shared/Image';
import Link from '@/shared/Link';
import Span from '@/shared/Span';

type MenuNavProps = {
  dataTestId?: string;
  image: any;
  label: string;
  subLabel?: string;
  key?: string | number;
  href: string;
  target?: string;
  width?: number;
};

function MenuNav({
  dataTestId,
  image,
  label,
  subLabel,
  href,
  target = '_self',
  width,
}: MenuNavProps) {
  return (
    <Link href={href} target={target} className="font-primary bg ">
      <Div
        className="w-[116px] md:w-[142px] whitespace-normal  py-s4 flex flex-col items-center gap-s2 cursor-pointer"
        dataTestId={dataTestId}
        style={{
          width,
        }}
      >
        <Div className="w-s8 md:w-14 h-s8 md:h-14">
          <Image alt={label} src={image} width={56} height={56} quality={100} />
        </Div>
        <Span className="text-body-base md:text-body-xl text-center text-cti-primary break-word">
          {label}
        </Span>

        <Span className="text-body-sm text-cm-brand">{subLabel}</Span>
      </Div>
    </Link>
  );
}

export default React.memo(MenuNav);
